import { publish } from '@shared/hooks/helpers/EventCallback';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import { useEffect } from 'react';
import AuthContainer from '../../hooks/state/AuthContainer';

const TokenRefresher = () => {
    const authContainer = AuthContainer.useContainer();
    const currentUserContainer = CurrentUserContainer.useContainer();
    const REFRESH_MS = 25 * 60 * 1000; // 25 mins

    useEffect(() => {
        const interval = setInterval(async () => {
            if (!authContainer.isLoadingRef.current) {
                await authContainer.getNewToken();
                await currentUserContainer.loadUserLicenseAccess();
                publish('force-reconnect');
            }
        }, REFRESH_MS);

        return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, []);

    return <></>;
};

export default TokenRefresher;
